// پروفایل — the editable profile, appearance, and the way out.
export const profile = {
  // ── profile ──────────────────────────────────────────────────────────
  'profile.title': 'پروفایل',
  'profile.sections.identity': 'مشخصات شما',
  'profile.sections.account': 'حساب کاربری',
  'profile.sections.appearance': 'ظاهر و زبان',
  'profile.fields.phone': 'شمارهٔ موبایل',
  'profile.fields.studentId': 'شناسهٔ حساب',
  'profile.fields.cases': 'بیماران تمرینی',
  'profile.fields.balance': 'موجودی پارسه',
  'profile.identity.note': 'شمارهٔ موبایل شما از حساب ورود پارسینا خوانده می‌شود و تغییر آن از همان‌جا انجام می‌شود، نه اینجا.',
  'profile.saved': 'پروفایل ذخیره شد.',
  'profile.appearance.theme': 'رنگ تأکیدی',
  'profile.appearance.fontSize': 'اندازهٔ متن',
  'profile.appearance.language': 'زبان',
  'profile.appearance.localOnly': 'این تنظیم‌ها فقط در همین مرورگر ذخیره می‌شوند و به دستگاه دیگر منتقل نمی‌شوند.',
  'profile.theme.default': 'آبی پارسینا',
  'profile.theme.teal': 'فیروزه‌ای',
  'profile.theme.ocean': 'لاجوردی',
  'profile.theme.slate': 'خاکستری آبی',
  'profile.fontSize.small': 'کوچک',
  'profile.fontSize.medium': 'متوسط',
  'profile.fontSize.large': 'بزرگ',
  'profile.language.fa': 'فارسی',
  'profile.language.en': 'English',
  'profile.logout': 'خروج از حساب',
};

export default profile;
